import { GiftHeader, SavedRecipientSelect, RecipientContact } from "./RecipientContact";
import { AddressQuestion, KnownAddress, UnknownAddress, DeliveryPin } from "./AddressBlocks";
import { DateWindowFields, CardMessage, CallPreference } from "./DeliveryDetails";

// One delivery leg of step 2: recipient, address, slot, card and call preference.
export const GiftForm = ({ locale, idx, g, r, errs, matching, countryList, maps, answerRequired, locReq,
                           setRec, onPickSaved, onRemove, onAsk, onShare, onCopy, updateGift, minDate, windowSelectable }) => {
  const set = (k, v) => setRec(g.gift_id, k, v);
  return (
    <div className="card p-5 space-y-4" data-testid={`gift-form-${idx}`}>
      <GiftHeader locale={locale} g={g} idx={idx} onRemove={onRemove} />
      {matching.length ? <SavedRecipientSelect locale={locale} idx={idx} matching={matching} onPick={onPickSaved} /> : null}
      <RecipientContact locale={locale} idx={idx} r={r} errs={errs} set={set} countryList={countryList} answerRequired={answerRequired} />
      <AddressQuestion locale={locale} idx={idx} r={r} answerRequired={answerRequired}
                       onKnown={() => set("knows_address", true)}
                       onUnknown={() => {
                         set("knows_address", false);
                         set("call_before_delivery", true);
                         if (!locReq) onAsk();
                       }} />
      {r.knows_address === true ? <KnownAddress locale={locale} idx={idx} g={g} r={r} errs={errs} set={set} apiKey={maps.google_maps_api_key} /> : null}
      {r.knows_address === false ? (
        <UnknownAddress locale={locale} idx={idx} r={r} errs={errs} set={set} req={locReq} onAsk={onAsk} onShare={onShare} onCopy={onCopy} />
      ) : null}
      {r.knows_address === true && maps.delivery_pin_enabled !== false ? <DeliveryPin locale={locale} idx={idx} g={g} r={r} set={set} maps={maps} /> : null}
      <DateWindowFields locale={locale} idx={idx} g={g} minDate={minDate} windowSelectable={windowSelectable} updateGift={updateGift} />
      <CardMessage locale={locale} idx={idx} g={g} updateGift={updateGift} />
      <CallPreference locale={locale} idx={idx} r={r} set={set} />
    </div>
  );
};
